import { TagFormElement } from './TagFormElement';
import { ITag } from './ITag';
import { Tag } from './Tag';

namespace app.model.tagging {

  export class TagFormElementTag extends TagFormElement {
    public readonly tagId: string;
    public readonly children: Array<ITag>;
    public readonly exclusions: Array<ITag>;
    public readonly inverseTag: ITag;
    public readonly tag: ITag;

    public constructor({
                         id = "",
                         tagId = "",
                         tag = new Tag(""),
                         type = "",
                         sortOrder = 0,
                         children = [],
                         exclusions = [],
                         inverseTag = new Tag("")
                       }) {
      super(id, sortOrder, type, "io.indexed.domainmodel.tagging.TagFormElementTag");

      this.tagId = tagId;
      this.children = children;
      this.exclusions = exclusions;
      this.inverseTag = inverseTag;
      this.tag = tag;
    }
  }
}
